import React from "react";
import { useHistory } from "react-router";
import { UilClipboardAlt } from "@iconscout/react-unicons";
import { LocalOfferOutlined } from "@material-ui/icons";
import Button from "@mui/material/Button";
import PageLayout from "../PageLayout/PageLayout";
import "./Promotions.css";

const Promotions = () => {
  const history = useHistory();
  return (
    <PageLayout
      icon={UilClipboardAlt}
      title="Promotions & Vouchers"
      subtitle="Discover exclusive deals and discounts"
    >
      <div className="promotions-empty-state-container">
        <div className="promotions-empty-state-content">
          <div className="promotions-empty-state-icon-wrapper">
            <LocalOfferOutlined className="promotions-empty-state-icon" />
          </div>
          <h3 className="promotions-empty-state-title">No Promotions Available</h3>
          <p className="promotions-empty-state-description">
            There are no active promotions or vouchers at the moment. Check back soon for exclusive deals and discounts!
          </p>
          <Button
            variant="contained"
            className="promotions-shop-now-button"
            onClick={() => history.push("/")}
            startIcon={<LocalOfferOutlined />}
          >
            Browse Products
          </Button>
        </div>
      </div>
    </PageLayout>
  );
};

export default Promotions;
